import styled, { css } from 'styled-components';

// Button
export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 150ms ease;
  text-decoration: none;
  padding: ${({ size }) => size === 'lg' ? '1rem 2rem' : size === 'sm' ? '0.5rem 1rem' : '0.75rem 1.5rem'};
  font-size: ${({ size }) => size === 'lg' ? '1.125rem' : size === 'sm' ? '0.875rem' : '1rem'};
  
  ${({ variant }) => variant === 'outline' ? css`
    background: transparent;
    color: #0f0f0f;
    border: 2px solid #0f0f0f;
    &:hover { background: #0f0f0f; color: white; }
  ` : variant === 'secondary' ? css`
    background: #0f0f0f;
    color: white;
    &:hover { background: #374151; }
  ` : css`
    background: #eab308;
    color: #0f0f0f;
    &:hover { background: #ca9a06; }
  `}
  
  ${({ $fullWidth }) => $fullWidth && css`width: 100%;`}
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

// Container
export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  @media (min-width: 768px) { padding: 0 1.5rem; }
`;

// Section
export const Section = styled.section`
  padding: 4rem 0;
  @media (max-width: 768px) { padding: 3rem 0; }
  ${({ $dark }) => $dark && css`background: #0f0f0f; color: white; h1,h2,h3,h4,h5,h6 { color: white; }`}
  ${({ $muted }) => $muted && css`background: #f9fafb;`}
  ${({ $yellow }) => $yellow && css`background: #fef3c7;`}
`;

// Grid
export const Grid = styled.div`
  display: grid;
  gap: ${({ gap }) => gap || '1.5rem'};
  grid-template-columns: repeat(${({ cols }) => cols || 1}, 1fr);
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;
